import _toConsumableArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/Users/harshsharma/Desktop/accio-private/acciojob-maincourse/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { isValid, getDay, format, startOfMonth, differenceInMinutes, addMinutes, isSameDay, isSameMinute, isPast, isAfter, isToday, subMonths, addMonths, subDays, addDays } from 'date-fns';
import * as React from 'react';
import React__default, { useState, useEffect } from 'react';
import Calendar from 'react-calendar';
import rgba from 'color-rgba';
import styled from 'styled-components';
var Arrow = function Arrow(_ref) {
  var direction = _ref.direction;
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "26",
    height: "26",
    viewBox: "0 0 512 512"
  }, React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "48",
    d: direction === 'back' ? 'M328 112L184 256l144 144' : 'M184.001 400L328.001 256L184.001 112'
  }));
};
var StyledCalendar = styled(Calendar)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.react-calendar,\n  &.react-calendar *,\n  &.react-calendar *:before,\n  &.react-calendar *:after {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n  button {\n    margin: 0;\n    border: 0;\n    outline: none;\n  }\n  button:enabled:hover {\n    cursor: pointer;\n  }\n  .react-calendar__navigation {\n    height: 44px;\n    margin-bottom: 1em;\n  }\n  .react-calendar__navigation button {\n    min-width: 44px;\n    background: none;\n  }\n  .react-calendar__navigation button:enabled:hover,\n  .react-calendar__navigation button:enabled:focus {\n    background-color: #e6e6e6;\n  }\n  .react-calendar__navigation button[disabled] {\n    background-color: #f0f0f0;\n  }\n  .react-calendar__month-view__weekdays {\n    text-align: center;\n    text-transform: uppercase;\n    font-weight: bold;\n    font-size: 0.75em;\n  }\n  .react-calendar__month-view__weekdays__weekday {\n    padding: 0.5em;\n  }\n  .react-calendar__month-view__weekNumbers {\n    font-weight: bold;\n  }\n  .react-calendar__month-view__weekNumbers .react-calendar__tile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75em;\n    padding: calc(0.75em / 0.75) calc(0.5em / 0.75);\n  }\n\n  .react-calendar__year-view .react-calendar__tile,\n  .react-calendar__decade-view .react-calendar__tile,\n  .react-calendar__century-view .react-calendar__tile {\n    padding: 2em 0.5em;\n  }\n  .react-calendar__tile {\n    max-width: 100%;\n    text-align: center;\n    padding: 0.75em 0.5em;\n    background: none;\n  }\n\n  .day-tile {\n    width: 60px;\n    height: 60px;\n    @media (max-width: 768px) {\n      height: 45px;\n    }\n    color: rgb(167, 167, 167);\n    padding: 5px;\n    position: relative;\n    z-index: 1;\n    &::after {\n      content: '';\n      position: absolute;\n      left: 2px;\n      top: 2px;\n      bottom: 2px;\n      right: 2px;\n      z-index: -1;\n    }\n  }\n\n  .day-tile abbr {\n    font-weight: bold;\n    font-size: 15.33px;\n  }\n\n  .react-calendar__month-view__days__day--neighboringMonth {\n    color: rgb(218, 218, 218);\n  }\n\n  button {\n    margin-top: 2.5px !important;\n    margin-bottom: 2.5px !important;\n  }\n\n  .active-day-tile {\n    &::after {\n      background: ", ";\n      border-radius: ", "px;\n    }\n    color: ", ";\n  }\n\n  .active-day-tile:hover {\n    opacity: 0.5;\n  }\n\n  .react-calendar__tile:disabled.day-tile {\n    background-color: #fff;\n  }\n\n  .react-calendar__tile--now.day-tile {\n    background: #fff;\n    &::after {\n      border-radius: ", "px;\n      background: ", ";\n    }\n  }\n\n  .react-calendar__tile--now:hover.day-tile {\n    background: #fff;\n    &::after {\n      border-radius: ", "px;\n      background: ", ";\n    }\n  }\n\n  .react-calendar__tile:hover.day-tile {\n    background: #fff;\n  }\n\n  .react-calendar__tile--active.day-tile {\n    background: #fff;\n    color: ", ";\n    &::after {\n      border-radius: ", "px;\n      border: solid ", " 1px;\n    }\n  }\n\n  .react-calendar__tile--active:enabled.day-tile,\n  .react-calendar__tile--active:enabled:focus.day-tile {\n    &::after {\n      background: ", ";\n      border-radius: ", "px;\n      border: solid ", " 1px;\n    }\n    &.react-calendar__tile--now {\n      &::after {\n        background: ", ";\n      }\n    }\n  }\n\n  /* month day titles */\n  .react-calendar__month-view__weekdays__weekday abbr {\n    text-decoration: none;\n    font-weight: normal;\n    color: #333;\n    font-size: 14px;\n    font-weight: 700;\n  }\n\n  .react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {\n    color: #333;\n  }\n\n  /* calendar styles */\n  &.react-calendar {\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans',\n      'Droid Sans', 'Helvetica Neue', sans-serif;\n    border: none !important;\n    width: 100% !important;\n    min-height: 390px;\n    @media (max-width: 768px) {\n      min-height: 302px;\n    }\n  }\n"])), function (_ref2) {
  var primaryColorFaded = _ref2.primaryColorFaded;
  return primaryColorFaded;
}, function (_ref3) {
  var borderRadius = _ref3.borderRadius;
  return borderRadius;
}, function (_ref4) {
  var primaryColor = _ref4.primaryColor;
  return primaryColor;
}, function (_ref5) {
  var borderRadius = _ref5.borderRadius;
  return borderRadius;
}, function (_ref6) {
  var primaryColorToday = _ref6.primaryColorToday;
  return primaryColorToday;
}, function (_ref7) {
  var borderRadius = _ref7.borderRadius;
  return borderRadius;
}, function (_ref8) {
  var primaryColorToday = _ref8.primaryColorToday;
  return primaryColorToday;
}, function (_ref9) {
  var primaryColor = _ref9.primaryColor;
  return primaryColor;
}, function (_ref10) {
  var borderRadius = _ref10.borderRadius;
  return borderRadius;
}, function (_ref11) {
  var primaryColorToday = _ref11.primaryColorToday;
  return primaryColorToday;
}, function (_ref12) {
  var primaryColorFaded = _ref12.primaryColorFaded;
  return primaryColorFaded;
}, function (_ref13) {
  var borderRadius = _ref13.borderRadius;
  return borderRadius;
}, function (_ref14) {
  var primaryColor = _ref14.primaryColor;
  return primaryColor;
}, function (_ref15) {
  var primaryColorToday = _ref15.primaryColorToday;
  return primaryColorToday;
});
var formatDate = function formatDate(date, locale) {
  return format(date, 'MM/dd/yyyy', {
    locale: locale
  });
};
var ScheduleCalendar = function ScheduleCalendar(_ref16) {
  var availableTimeslots = _ref16.availableTimeslots,
    onDaySelected = _ref16.onDaySelected,
    selectedDay = _ref16.selectedDay,
    borderRadius = _ref16.borderRadius,
    primaryColor = _ref16.primaryColor,
    primaryColorFaded = _ref16.primaryColorFaded,
    locale = _ref16.locale;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    daysAvailable = _useState2[0],
    setDaysAvailable = _useState2[1];
  var _ref17 = rgba(primaryColor) || [0, 0, 0, 1],
    _ref18 = _slicedToArray(_ref17, 4),
    r = _ref18[0],
    g = _ref18[1],
    b = _ref18[2],
    alpha = _ref18[3];
  var primaryColorToday = "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha / 4.5, ")");
  useEffect(function () {
    var daysInTimeslots = [];
    availableTimeslots.map(function (slot) {
      if (!isValid(new Date(slot.startTime))) throw new Error("Invalid date for start time on slot ".concat(slot.id));
      if (!isValid(new Date(slot.endTime))) throw new Error("Invalid date for end time on slot ".concat(slot.id));
      var startTimeDay = getDay(new Date(slot.startTime));
      var endTimeDay = getDay(new Date(slot.endTime));
      if (startTimeDay !== endTimeDay) {
        daysInTimeslots.push(formatDate(new Date(slot.endTime), locale));
      }
      daysInTimeslots.push(formatDate(new Date(slot.startTime), locale));
      return null;
    });
    setDaysAvailable(_toConsumableArray(new Set(daysInTimeslots)));
  }, [availableTimeslots]);
  var _onClickDay = function _onClickDay(day) {
    onDaySelected(day);
  };
  var _isTileDisabled = function _isTileDisabled(props) {
    return props.view === 'month' && !daysAvailable.some(function (date) {
      return date === formatDate(props.date, locale);
    });
  };
  var _renderClassName = function _renderClassName(props) {
    if (daysAvailable.some(function (date) {
      return date === formatDate(props.date, locale);
    })) return ['day-tile', 'active-day-tile'];
    return props.view === 'month' && 'day-tile' || null;
  };
  return React__default.createElement(StyledCalendar, {
    borderRadius: borderRadius,
    primaryColor: primaryColor,
    primaryColorFaded: primaryColorFaded,
    primaryColorToday: primaryColorToday,
    defaultView: 'month',
    onClickDay: _onClickDay,
    showNavigation: false,
    tileDisabled: _isTileDisabled,
    tileClassName: _renderClassName,
    value: selectedDay,
    activeStartDate: startOfMonth(selectedDay)
  });
};
var ThemedButton = styled.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 16px;\n  border: none;\n  color: ", ";\n  background-color: ", ";\n  border-radius: ", "px;\n  outline: none;\n  width: 100%;\n  cursor: pointer;\n  font-size: 16px;\n  opacity: 1;\n  :hover {\n    opacity: 0.8;\n    background-color: ", ";\n  }\n"])), function (_ref19) {
  var selected = _ref19.selected;
  return selected ? "rgb(255, 255, 255)" : "rgb(20,20,20)";
}, function (_ref20) {
  var selected = _ref20.selected,
    primaryColor = _ref20.primaryColor;
  return selected ? primaryColor : "rgba(0,0,0,0)";
}, function (_ref21) {
  var borderRadius = _ref21.borderRadius;
  return borderRadius;
}, function (_ref22) {
  var selected = _ref22.selected,
    primaryColor = _ref22.primaryColor,
    primaryColorFaded = _ref22.primaryColorFaded;
  return selected ? primaryColor : primaryColorFaded;
});
var StartTimeGridItemButton = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 12px 16px;\n  margin: 4px;\n  border: none;\n  color: white;\n  background-color: ", ";\n  border-radius: ", "px;\n  outline: none;\n  cursor: pointer;\n  font-size: 16px;\n  opacity: 1;\n  @media (max-width: 768px) {\n    padding: 7px 12px;\n  }\n  :hover {\n    opacity: 0.8;\n  }\n"])), function (_ref23) {
  var primaryColor = _ref23.primaryColor;
  return primaryColor;
}, function (_ref24) {
  var borderRadius = _ref24.borderRadius;
  return borderRadius;
});

/* eslint-disable  */
var Container$1 = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n"])));
var CancelButton = styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 8px 24px;\n  border: none;\n  background-color: rgb(0, 0, 0, 0);\n  border-radius: ", "px;\n  outline: none;\n  margin-left: 8px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  height: 100%;\n  color: #222320;\n  :hover {\n    background-color: rgba(0, 0, 0, 0.03);\n  }\n"])), function (_ref25) {
  var borderRadius = _ref25.borderRadius;
  return borderRadius;
});
var StartTimeListItem = function StartTimeListItem(_ref26) {
  var onStartTimeSelect = _ref26.onStartTimeSelect,
    startTimeEvent = _ref26.startTimeEvent,
    selected = _ref26.selected,
    onCancelClicked = _ref26.onCancelClicked,
    borderRadius = _ref26.borderRadius,
    primaryColor = _ref26.primaryColor,
    primaryColorFaded = _ref26.primaryColorFaded,
    format_startTimeFormatString = _ref26.format_startTimeFormatString,
    lang_confirmButtonText = _ref26.lang_confirmButtonText,
    lang_cancelButtonText = _ref26.lang_cancelButtonText,
    locale = _ref26.locale;
  return React__default.createElement(Container$1, {
    className: "rsm-start-time-item"
  }, React__default.createElement(ThemedButton, {
    type: "button",
    className: "rsm-confirm-button",
    selected: Boolean(selected),
    borderRadius: borderRadius,
    primaryColorFaded: primaryColorFaded,
    primaryColor: primaryColor,
    onClick: onStartTimeSelect
  }, selected && "".concat(lang_confirmButtonText, " "), format(startTimeEvent.startTime, format_startTimeFormatString, {
    locale: locale
  })), selected && React__default.createElement(CancelButton, {
    type: "button",
    className: "rsm-cancel-button",
    borderRadius: borderRadius,
    onClick: onCancelClicked
  }, lang_cancelButtonText));
};
var ScrollListContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  overflow-y: scroll;\n  padding-bottom: 24px;\n  padding-top: 16px;\n"])));
var GridContainer = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  overflow-y: scroll;\n  align-items: stretch;\n  justify-content: flex-start;\n"])));
var ScrollEdgeFade = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 24px;\n  left: 0;\n  right: 0;\n  z-index: 12;\n  pointer-events: none;\n  &.top {\n    background: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(0, 0, 0, 0));\n    top: 42px;\n  }\n  &.bottom {\n    bottom: 0;\n    background: linear-gradient(0deg, rgba(255, 255, 255, 1), rgba(0, 0, 0, 0));\n  }\n"])));
var ListItemDivider = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  flex-shrink: 0;\n  flex: 1;\n  padding: 0.5px;\n  margin: 0px 8px;\n  position: relative;\n  background: ", ";\n"])), function (_ref27) {
  var makeTransparent = _ref27.makeTransparent;
  return makeTransparent ? "transparent" : "rgba(0, 0, 0, 0.05)";
});
var StyledP = styled.p(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  margin: 0;\n  opacity: 0.5;\n  margin-bottom: 24px;\n  font-size: 18px;\n"])));
var NoTimesAvailableContainer = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  height: 100%;\n  flex: 1;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"])));
var GoToNextAvailableDayButton = styled(ThemedButton)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  border: none;\n  padding: 6px 18px;\n  width: auto;\n  text-align: left;\n  p {\n    margin: 0;\n    color: inherit;\n    font-weight: inherit;\n    text-align: inherit;\n  }\n  small {\n    font-weight: 700;\n  }\n  display: flex;\n  align-items: center;\n  svg {\n    margin-left: 14px;\n    margin-right: -4px;\n  }\n"])));
var NoFutureTimesText = styled(StyledP)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-size: 90%;\n  font-weight: 700;\n  padding: 3px 10px;\n  border-radius: ", "px;\n  border: 1px solid rgba(0, 0, 0, 0.5);\n"])), function (_ref28) {
  var borderRadius = _ref28.borderRadius;
  return borderRadius;
});
var StartTimeList = function StartTimeList(_ref29) {
  var _ref29$startTimeListI = _ref29.startTimeListItems,
    startTimeListItems = _ref29$startTimeListI === void 0 ? [] : _ref29$startTimeListI,
    onStartTimeSelect = _ref29.onStartTimeSelect,
    emptyListContentEl = _ref29.emptyListContentEl,
    lang_emptyListText = _ref29.lang_emptyListText,
    borderRadius = _ref29.borderRadius,
    primaryColorFaded = _ref29.primaryColorFaded,
    primaryColor = _ref29.primaryColor,
    format_startTimeFormatString = _ref29.format_startTimeFormatString,
    lang_confirmButtonText = _ref29.lang_confirmButtonText,
    lang_cancelButtonText = _ref29.lang_cancelButtonText,
    lang_goToNextAvailableDayText = _ref29.lang_goToNextAvailableDayText,
    lang_noFutureTimesText = _ref29.lang_noFutureTimesText,
    onGoToNextAvailableDayClick = _ref29.onGoToNextAvailableDayClick,
    nextFutureStartTimeAvailable = _ref29.nextFutureStartTimeAvailable,
    format_nextFutureStartTimeAvailableFormatString = _ref29.format_nextFutureStartTimeAvailableFormatString,
    startTimeListStyle = _ref29.startTimeListStyle,
    locale = _ref29.locale;
  var _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItemIndex = _useState4[0],
    setSelectedItemIndex = _useState4[1];
  var _onStartTimeSelect = function _onStartTimeSelect(startTimeEvent, index) {
    if (selectedItemIndex === index) {
      onStartTimeSelect(startTimeEvent);
    } else {
      setSelectedItemIndex(index);
    }
  };
  var emptyListElement = React__default.createElement(NoTimesAvailableContainer, null, emptyListContentEl || React__default.createElement(StyledP, {
    className: "rsm-empty-list-text"
  }, lang_emptyListText), nextFutureStartTimeAvailable ? React__default.createElement(GoToNextAvailableDayButton, {
    type: "button",
    selected: true,
    className: "rsm-next-available-date-button",
    borderRadius: borderRadius,
    primaryColorFaded: primaryColorFaded,
    primaryColor: primaryColor,
    onClick: onGoToNextAvailableDayClick
  }, React__default.createElement("p", null, React__default.createElement("small", null, lang_goToNextAvailableDayText), React__default.createElement("br", null), format(nextFutureStartTimeAvailable, format_nextFutureStartTimeAvailableFormatString, {
    locale: locale
  })), React__default.createElement(Arrow, {
    direction: "forward"
  })) : React__default.createElement(NoFutureTimesText, {
    borderRadius: borderRadius,
    className: "rsm-no-future-times-text"
  }, lang_noFutureTimesText));
  return React__default.createElement(React__default.Fragment, null, startTimeListItems.length === 0 ? emptyListElement : startTimeListStyle === 'scroll-list' ? React__default.createElement(React__default.Fragment, null, React__default.createElement(ScrollEdgeFade, {
    className: "top"
  }), React__default.createElement(ScrollEdgeFade, {
    className: "bottom"
  }), React__default.createElement(ScrollListContainer, null, startTimeListItems.map(function (startTimeEvent, i) {
    return React__default.createElement(React__default.Fragment, {
      key: i
    }, React__default.createElement(StartTimeListItem, {
      locale: locale,
      lang_confirmButtonText: lang_confirmButtonText,
      lang_cancelButtonText: lang_cancelButtonText,
      format_startTimeFormatString: format_startTimeFormatString,
      primaryColorFaded: primaryColorFaded,
      borderRadius: borderRadius,
      primaryColor: primaryColor,
      onCancelClicked: function onCancelClicked() {
        return setSelectedItemIndex(-1);
      },
      selected: i === selectedItemIndex,
      startTimeEvent: startTimeEvent,
      onStartTimeSelect: function onStartTimeSelect() {
        return _onStartTimeSelect(startTimeEvent, i);
      }
    }), i !== startTimeListItems.length - 1 && React__default.createElement(ListItemDivider, {
      makeTransparent: selectedItemIndex === i || selectedItemIndex === i + 1
    }));
  }))) : React__default.createElement(GridContainer, null, startTimeListItems.map(function (startTimeEvent, i) {
    return React__default.createElement(StartTimeGridItemButton, {
      key: i,
      type: "button",
      primaryColorFaded: primaryColorFaded,
      borderRadius: borderRadius,
      primaryColor: primaryColor,
      onClick: function onClick() {
        return onStartTimeSelect(startTimeEvent);
      }
    }, format(startTimeEvent.startTime, format_startTimeFormatString, {
      locale: locale
    }));
  })));
};
var Container = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Inner = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  border-radius: ", "px;\n  box-shadow: 0 5px 22px rgba(20, 21, 21, 0.22), 0px 1px 4px rgba(20, 21, 21, 0.14);\n  padding: 16px;\n  margin: 16px;\n  flex-direction: column;\n  background: white;\n  @media (min-width: 768px) {\n    flex-direction: row;\n  }\n  @media (max-width: 768px) {\n    padding: 8px;\n    margin: 8px;\n  }\n"])), function (_ref30) {
  var borderRadius = _ref30.borderRadius;
  return borderRadius;
});
var Divider = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  width: 1px;\n  background: rgba(0, 0, 0, 0.1);\n  margin: 16px;\n  @media (max-width: 768px) {\n    width: auto;\n    height: 1px;\n  }\n"])));
var CalendarContainer = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  flex: 1;\n"])));
var StartTimeListContainer = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  flex: 1;\n  overflow: hidden;\n  position: relative;\n  @media (max-width: 768px) {\n    min-height: 301px;\n  }\n"])));
var StartTimeListContainerAbsolute = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var SelectedDayTitle = styled.h3(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  font-weight: 700;\n  font-size: 24px;\n"])));
var Header = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 6px;\n"])));
var ArrowButton = styled.button(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  outline: none;\n  background: none;\n  border: none;\n  border-radius: ", "px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  opacity: 0.4;\n  margin: 0;\n  color: #222320;\n  &:hover {\n    opacity: 0.7;\n    background: rgba(0, 0, 0, 0.03);\n  }\n"])), function (_ref31) {
  var borderRadius = _ref31.borderRadius;
  return borderRadius;
});
var ScheduleMeeting = function ScheduleMeeting(_ref32) {
  var _ref32$availableTimes = _ref32.availableTimeslots,
    availableTimeslots = _ref32$availableTimes === void 0 ? [] : _ref32$availableTimes,
    _ref32$borderRadius = _ref32.borderRadius,
    borderRadius = _ref32$borderRadius === void 0 ? 0 : _ref32$borderRadius,
    _ref32$primaryColor = _ref32.primaryColor,
    primaryColor = _ref32$primaryColor === void 0 ? '#3f5b85' : _ref32$primaryColor,
    emptyListContentEl = _ref32.emptyListContentEl,
    _ref32$lang_emptyList = _ref32.lang_emptyListText,
    lang_emptyListText = _ref32$lang_emptyList === void 0 ? 'No times available' : _ref32$lang_emptyList,
    _ref32$eventStartTime = _ref32.eventStartTimeSpreadInMinutes,
    eventStartTimeSpreadInMinutes = _ref32$eventStartTime === void 0 ? 0 : _ref32$eventStartTime,
    _ref32$eventDurationI = _ref32.eventDurationInMinutes,
    eventDurationInMinutes = _ref32$eventDurationI === void 0 ? 30 : _ref32$eventDurationI,
    onSelectedDayChange = _ref32.onSelectedDayChange,
    onStartTimeSelect = _ref32.onStartTimeSelect,
    scheduleMeetingStyles = _ref32.scheduleMeetingStyles,
    defaultDate = _ref32.defaultDate,
    _ref32$format_selecte = _ref32.format_selectedDateDayTitleFormatString,
    format_selectedDateDayTitleFormatString = _ref32$format_selecte === void 0 ? 'cccc, LLLL do' : _ref32$format_selecte,
    _ref32$format_selecte2 = _ref32.format_selectedDateMonthTitleFormatString,
    format_selectedDateMonthTitleFormatString = _ref32$format_selecte2 === void 0 ? 'LLLL yyyy' : _ref32$format_selecte2,
    _ref32$format_startTi = _ref32.format_startTimeFormatString,
    format_startTimeFormatString = _ref32$format_startTi === void 0 ? 'h:mm a' : _ref32$format_startTi,
    _ref32$lang_confirmBu = _ref32.lang_confirmButtonText,
    lang_confirmButtonText = _ref32$lang_confirmBu === void 0 ? 'Confirm' : _ref32$lang_confirmBu,
    _ref32$lang_cancelBut = _ref32.lang_cancelButtonText,
    lang_cancelButtonText = _ref32$lang_cancelBut === void 0 ? 'Cancel' : _ref32$lang_cancelBut,
    _ref32$lang_noFutureT = _ref32.lang_noFutureTimesText,
    lang_noFutureTimesText = _ref32$lang_noFutureT === void 0 ? 'No future times available' : _ref32$lang_noFutureT,
    _ref32$lang_goToNextA = _ref32.lang_goToNextAvailableDayText,
    lang_goToNextAvailableDayText = _ref32$lang_goToNextA === void 0 ? 'Next Available' : _ref32$lang_goToNextA,
    _ref32$format_nextFut = _ref32.format_nextFutureStartTimeAvailableFormatString,
    format_nextFutureStartTimeAvailableFormatString = _ref32$format_nextFut === void 0 ? 'cccc, LLLL do' : _ref32$format_nextFut,
    onNoFutureTimesAvailable = _ref32.onNoFutureTimesAvailable,
    _ref32$startTimeListS = _ref32.startTimeListStyle,
    startTimeListStyle = _ref32$startTimeListS === void 0 ? 'grid' : _ref32$startTimeListS,
    locale = _ref32.locale;
  var _ref33 = rgba(primaryColor) || [0, 0, 0, 1],
    _ref34 = _slicedToArray(_ref33, 4),
    r = _ref34[0],
    g = _ref34[1],
    b = _ref34[2],
    alpha = _ref34[3];
  var primaryColorRGB = "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha, ")");
  var primaryColorFaded = "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(alpha / 9, ")");
  var _React__default$useSt = React__default.useState(new Date()),
    _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
    selectedDay = _React__default$useSt2[0],
    setSelectedDay = _React__default$useSt2[1];
  var _React__default$useSt3 = React__default.useState([]),
    _React__default$useSt4 = _slicedToArray(_React__default$useSt3, 2),
    startTimeEventsList = _React__default$useSt4[0],
    setStartTimeEventsList = _React__default$useSt4[1];
  var _React__default$useSt5 = React__default.useState([]),
    _React__default$useSt6 = _slicedToArray(_React__default$useSt5, 2),
    selectedDayStartTimeEventsList = _React__default$useSt6[0],
    setSelectedDayStartTimeEventsList = _React__default$useSt6[1];
  var _React__default$useSt7 = React__default.useState(),
    _React__default$useSt8 = _slicedToArray(_React__default$useSt7, 2),
    nextFutureStartTimeAvailable = _React__default$useSt8[0],
    setNextFutureStartTimeAvailable = _React__default$useSt8[1];
  var _React__default$useSt9 = React__default.useState([]),
    _React__default$useSt10 = _slicedToArray(_React__default$useSt9, 2),
    orderedAvailableTimeslots = _React__default$useSt10[0],
    setOrderedAvailableTimeslots = _React__default$useSt10[1];
  useEffect(function () {
    var _orderedAvailableTimeslots = _toConsumableArray(availableTimeslots);
    _orderedAvailableTimeslots.sort(function (a, b) {
      return new Date(a.startTime).getTime() - new Date(b.startTime).getTime();
    });
    setOrderedAvailableTimeslots(_orderedAvailableTimeslots);
  }, [availableTimeslots]);
  var onDaySelected = function onDaySelected(day) {
    setSelectedDay(day);
    onSelectedDayChange && onSelectedDayChange(day);
  };
  var splitTimeslot = function splitTimeslot(startTimeEvent) {
    var splitTimeslots = [null, null];
    var minutesIntoTimeslotEventWillStart = differenceInMinutes(startTimeEvent.startTime, new Date(startTimeEvent.availableTimeslot.startTime));
    if (minutesIntoTimeslotEventWillStart !== 0) {
      var newFirstTimeslot = {
        oldId: startTimeEvent.availableTimeslot.id,
        startTime: startTimeEvent.availableTimeslot.startTime,
        endTime: addMinutes(new Date(startTimeEvent.availableTimeslot.startTime), minutesIntoTimeslotEventWillStart)
      };
      splitTimeslots[0] = newFirstTimeslot;
    }
    var startTimeOfEndingSplitTimeslot = addMinutes(new Date(startTimeEvent.availableTimeslot.startTime), minutesIntoTimeslotEventWillStart + eventDurationInMinutes);
    if (differenceInMinutes(startTimeOfEndingSplitTimeslot, new Date(startTimeEvent.availableTimeslot.endTime)) !== 0) {
      var newSecondTimeslot = {
        oldId: startTimeEvent.availableTimeslot.id,
        startTime: startTimeOfEndingSplitTimeslot,
        endTime: startTimeEvent.availableTimeslot.endTime
      };
      splitTimeslots[1] = newSecondTimeslot;
    }
    return splitTimeslots;
  };
  var _onStartTimeSelect = function _onStartTimeSelect(startTimeEvent) {
    var splitTimeslots = splitTimeslot(startTimeEvent);
    var startTimeEventEmitObject = Object.assign(Object.assign({}, startTimeEvent), {
      splitTimeslot: splitTimeslots
    });
    if (onStartTimeSelect) {
      onStartTimeSelect(startTimeEventEmitObject);
    }
  };
  useEffect(function () {
    // compile a list of all possible event start times given all timeslots
    var startTimeEvents = [];
    // iterate through all available timeslots
    var _iterator = _createForOfIteratorHelper(orderedAvailableTimeslots),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var availableTimeslot = _step.value;
        var timeslotDuration = differenceInMinutes(new Date(availableTimeslot.endTime), new Date(availableTimeslot.startTime));
        // this prevents start times from being created where the event duration runs past the available timeslot
        var startTimesPossible = Math.floor(timeslotDuration / (eventDurationInMinutes + eventStartTimeSpreadInMinutes)) - 1;
        while (startTimesPossible >= 0) {
          var newStartTimeEvent = {
            availableTimeslot: availableTimeslot,
            startTime: addMinutes(new Date(availableTimeslot.startTime), startTimesPossible * (eventDurationInMinutes + eventStartTimeSpreadInMinutes))
          };
          startTimeEvents.push(newStartTimeEvent);
          startTimesPossible--;
        }
      }
      // set initial display date
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    if (defaultDate) {
      setSelectedDay(defaultDate);
    }
    setStartTimeEventsList(startTimeEvents);
  }, [orderedAvailableTimeslots, eventDurationInMinutes, eventStartTimeSpreadInMinutes, defaultDate]);
  useEffect(function () {
    var _a;
    var startTimeEventsToDisplay = [];
    // filter out startTimeEvents so we get the list of ones to display next to the calendar
    var _iterator2 = _createForOfIteratorHelper(startTimeEventsList),
      _step2;
    try {
      var _loop = function _loop() {
        var startTimeEvent = _step2.value;
        // make sure its the same day as the selected day
        if (isSameDay(startTimeEvent.startTime, selectedDay)) {
          // prevents duplicate times (in case there are multiple overlapping shifts)
          if (startTimeEventsToDisplay.filter(function (item) {
            return isSameMinute(item.startTime, startTimeEvent.startTime);
          }).length === 0) {
            if (!isPast(startTimeEvent.startTime)) {
              startTimeEventsToDisplay.push(startTimeEvent);
            }
          }
        }
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
      // order the events by first in the day
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    var orderedEvents = startTimeEventsToDisplay.sort(function (a, b) {
      return a.startTime.getTime() - b.startTime.getTime();
    });
    var _nextFutureStartTimeAvailable = (_a = startTimeEventsList.find(function (startTime) {
      return isAfter(startTime.startTime, selectedDay) && !isToday(startTime.startTime);
    })) === null || _a === void 0 ? void 0 : _a.startTime;
    if (startTimeEventsList.length > 0 && onNoFutureTimesAvailable && !_nextFutureStartTimeAvailable && orderedEvents.length === 0) {
      onNoFutureTimesAvailable(selectedDay);
    }
    setNextFutureStartTimeAvailable(_nextFutureStartTimeAvailable);
    setSelectedDayStartTimeEventsList(orderedEvents);
  }, [selectedDay, startTimeEventsList]);
  var goToPreviousMonth = function goToPreviousMonth() {
    setSelectedDay(subMonths(selectedDay, 1));
  };
  var goToNextMonth = function goToNextMonth() {
    setSelectedDay(addMonths(selectedDay, 1));
  };
  var goToPreviousDay = function goToPreviousDay() {
    setSelectedDay(subDays(selectedDay, 1));
  };
  var goToNextDay = function goToNextDay() {
    setSelectedDay(addDays(selectedDay, 1));
  };
  var handleGoToNextAvailableDay = function handleGoToNextAvailableDay() {
    if (nextFutureStartTimeAvailable) {
      setSelectedDay(nextFutureStartTimeAvailable);
    }
  };
  return React__default.createElement(Container, null, React__default.createElement(Inner, {
    borderRadius: borderRadius,
    style: scheduleMeetingStyles
  }, React__default.createElement(CalendarContainer, null, React__default.createElement(Header, null, React__default.createElement(ArrowButton, {
    type: "button",
    className: "rsm-arrow-button",
    borderRadius: borderRadius,
    onClick: goToPreviousMonth
  }, React__default.createElement(Arrow, {
    direction: "back"
  })), React__default.createElement(SelectedDayTitle, {
    className: "rsm-date-title"
  }, format(selectedDay, format_selectedDateMonthTitleFormatString, {
    locale: locale
  })), React__default.createElement(ArrowButton, {
    type: "button",
    className: "rsm-arrow-button",
    borderRadius: borderRadius,
    onClick: goToNextMonth
  }, React__default.createElement(Arrow, {
    direction: "forward"
  }))), React__default.createElement(ScheduleCalendar, {
    locale: locale,
    borderRadius: borderRadius,
    primaryColor: primaryColorRGB,
    selectedDay: selectedDay,
    availableTimeslots: orderedAvailableTimeslots,
    primaryColorFaded: primaryColorFaded,
    onDaySelected: onDaySelected
  })), React__default.createElement(Divider, null), React__default.createElement(StartTimeListContainer, null, React__default.createElement(StartTimeListContainerAbsolute, null, React__default.createElement(Header, null, React__default.createElement(ArrowButton, {
    type: "button",
    className: "rsm-arrow-button",
    borderRadius: borderRadius,
    onClick: goToPreviousDay
  }, React__default.createElement(Arrow, {
    direction: "back"
  })), React__default.createElement(SelectedDayTitle, {
    className: "rsm-date-title"
  }, format(selectedDay, format_selectedDateDayTitleFormatString, {
    locale: locale
  })), React__default.createElement(ArrowButton, {
    type: "button",
    className: "rsm-arrow-button",
    borderRadius: borderRadius,
    onClick: goToNextDay
  }, React__default.createElement(Arrow, {
    direction: "forward"
  }))), React__default.createElement(StartTimeList, {
    locale: locale,
    format_nextFutureStartTimeAvailableFormatString: format_nextFutureStartTimeAvailableFormatString,
    nextFutureStartTimeAvailable: nextFutureStartTimeAvailable,
    lang_goToNextAvailableDayText: lang_goToNextAvailableDayText,
    lang_noFutureTimesText: lang_noFutureTimesText,
    onGoToNextAvailableDayClick: handleGoToNextAvailableDay,
    lang_confirmButtonText: lang_confirmButtonText,
    lang_cancelButtonText: lang_cancelButtonText,
    lang_emptyListText: lang_emptyListText,
    primaryColorFaded: primaryColorFaded,
    primaryColor: primaryColorRGB,
    borderRadius: borderRadius,
    emptyListContentEl: emptyListContentEl,
    onStartTimeSelect: _onStartTimeSelect,
    startTimeListItems: selectedDayStartTimeEventsList,
    format_startTimeFormatString: format_startTimeFormatString,
    startTimeListStyle: startTimeListStyle
  })))));
};
export { ScheduleMeeting };